export const fieldsRadioPersonne = [
  { id: "moral", name: "personn", label: "Personne morale", type: "radio" },
  {
    id: "physique",
    name: "personn",
    label: "Personne physique",
    type: "radio",
  },
];

export const prefixes = [
  { value: "Monsieur", label: "Monsieur" },
  { value: "Madame", label: "Madame" },
];

export const fieldsRadioActif = [
  {
    id: "Inactive",
    name: "active",
    label: "Inactive",
    type: "radio",
    value: false,
  },
  {
    id: "Active",
    name: "active",
    label: "Active",
    type: "radio",
    value: true,
  },
];

export const pays = [
  { id: 1, title: "Afghanistan", iso2: "AF" },
  { id: 2, title: "Afrique du Sud", iso2: "ZA" },
  { id: 3, title: "Albanie", iso2: "AL" },
  { id: 4, title: "Algérie", iso2: "DZ" },
  { id: 5, title: "Allemagne", iso2: "DE" },
  { id: 6, title: "Andorre", iso2: "AD" },
  { id: 7, title: "Angola", iso2: "AO" },
  { id: 8, title: "Antigua-et-Barbuda", iso2: "AG" },
  { id: 9, title: "Arabie saoudite", iso2: "SA" },
  { id: 10, title: "Argentine", iso2: "AR" },
  { id: 11, title: "Arménie", iso2: "AM" },
  { id: 12, title: "Australie", iso2: "AU" },
  { id: 13, title: "Autriche", iso2: "AT" },
  { id: 14, title: "Azerbaïdjan", iso2: "AZ" },
  { id: 15, title: "Bahamas", iso2: "BS" },
  { id: 16, title: "Bahreïn", iso2: "BH" },
  { id: 17, title: "Bangladesh", iso2: "BD" },
  { id: 18, title: "Barbade", iso2: "BB" },
  { id: 19, title: "Belgique", iso2: "BE" },
  { id: 20, title: "Belize", iso2: "BZ" },
  { id: 21, title: "Bénin", iso2: "BJ" },
  { id: 22, title: "Bhoutan", iso2: "BT" },
  { id: 23, title: "Biélorussie", iso2: "BY" },
  { id: 24, title: "Birmanie", iso2: "MM" },
  { id: 25, title: "Bolivie", iso2: "BO" },
  { id: 26, title: "Bosnie-Herzégovine", iso2: "BA" },
  { id: 27, title: "Botswana", iso2: "BW" },
  { id: 28, title: "Brésil", iso2: "BR" },
  { id: 29, title: "Brunei", iso2: "BN" },
  { id: 30, title: "Bulgarie", iso2: "BG" },
  { id: 31, title: "Burkina Faso", iso2: "BF" },
  { id: 32, title: "Burundi", iso2: "BI" },
  { id: 33, title: "Cap-Vert", iso2: "CV" },
  { id: 34, title: "Cambodge", iso2: "KH" },
  { id: 35, title: "Cameroun", iso2: "CM" },
  { id: 36, title: "Canada", iso2: "CA" },
  { id: 37, title: "Chili", iso2: "CL" },
  { id: 38, title: "Chine", iso2: "CN" },
  { id: 39, title: "Chypre", iso2: "CY" },
  { id: 40, title: "Colombie", iso2: "CO" },
  { id: 41, title: "Comores", iso2: "KM" },
  { id: 42, title: "Congo", iso2: "CG" },
  { id: 43, title: "Corée du Nord", iso2: "KP" },
  { id: 44, title: "Corée du Sud", iso2: "KR" },
  { id: 45, title: "Costa Rica", iso2: "CR" },
  { id: 46, title: "Côte d’Ivoire", iso2: "CI" },
  { id: 47, title: "Croatie", iso2: "HR" },
  { id: 48, title: "Cuba", iso2: "CU" },
  { id: 49, title: "Danemark", iso2: "DK" },
  { id: 50, title: "Djibouti", iso2: "DJ" },
  { id: 51, title: "Dominique", iso2: "DM" },
  { id: 52, title: "Égypte", iso2: "EG" },
  { id: 53, title: "Émirats arabes unis", iso2: "AE" },
  { id: 54, title: "Équateur", iso2: "EC" },
  { id: 55, title: "Érythrée", iso2: "ER" },
  { id: 56, title: "Espagne", iso2: "ES" },
  { id: 57, title: "Estonie", iso2: "EE" },
  { id: 58, title: "Eswatini", iso2: "SZ" },
  { id: 59, title: "États-Unis", iso2: "US" },
  { id: 60, title: "Éthiopie", iso2: "ET" },
  { id: 61, title: "Fidji", iso2: "FJ" },
  { id: 62, title: "Finlande", iso2: "FI" },
  { id: 63, title: "France", iso2: "FR" },
  { id: 64, title: "Gabon", iso2: "GA" },
  { id: 65, title: "Gambie", iso2: "GM" },
  { id: 66, title: "Géorgie", iso2: "GE" },
  { id: 67, title: "Ghana", iso2: "GH" },
  { id: 68, title: "Grèce", iso2: "GR" },
  { id: 69, title: "Grenade", iso2: "GD" },
  { id: 70, title: "Guatemala", iso2: "GT" },
  { id: 71, title: "Guinée", iso2: "GN" },
  { id: 72, title: "Guinée-Bissau", iso2: "GW" },
  { id: 73, title: "Guinée équatoriale", iso2: "GQ" },
  { id: 74, title: "Guyana", iso2: "GY" },
  { id: 75, title: "Haïti", iso2: "HT" },
  { id: 76, title: "Honduras", iso2: "HN" },
  { id: 77, title: "Hongrie", iso2: "HU" },
  { id: 78, title: "Îles Marshall", iso2: "MH" },
  { id: 79, title: "Îles Salomon", iso2: "SB" },
  { id: 80, title: "Inde", iso2: "IN" },
  { id: 81, title: "Indonésie", iso2: "ID" },
  { id: 82, title: "Irak", iso2: "IQ" },
  { id: 83, title: "Iran", iso2: "IR" },
  { id: 84, title: "Irlande", iso2: "IE" },
  { id: 85, title: "Islande", iso2: "IS" },
  { id: 86, title: "Israël", iso2: "IL" },
  { id: 87, title: "Italie", iso2: "IT" },
  { id: 88, title: "Jamaïque", iso2: "JM" },
  { id: 89, title: "Japon", iso2: "JP" },
  { id: 90, title: "Jordanie", iso2: "JO" },
  { id: 91, title: "Kazakhstan", iso2: "KZ" },
  { id: 92, title: "Kenya", iso2: "KE" },
  { id: 93, title: "Kirghizistan", iso2: "KG" },
  { id: 94, title: "Kiribati", iso2: "KI" },
  { id: 95, title: "Koweït", iso2: "KW" },
  { id: 96, title: "Laos", iso2: "LA" },
  { id: 97, title: "Lesotho", iso2: "LS" },
  { id: 98, title: "Lettonie", iso2: "LV" },
  { id: 99, title: "Liban", iso2: "LB" },
  { id: 100, title: "Liberia", iso2: "LR" },
  { id: 101, title: "Libye", iso2: "LY" },
  { id: 102, title: "Liechtenstein", iso2: "LI" },
  { id: 103, title: "Lituanie", iso2: "LT" },
  { id: 104, title: "Luxembourg", iso2: "LU" },
  { id: 105, title: "Macédoine du Nord", iso2: "MK" },
  { id: 106, title: "Madagascar", iso2: "MG" },
  { id: 107, title: "Malaisie", iso2: "MY" },
  { id: 108, title: "Malawi", iso2: "MW" },
  { id: 109, title: "Maldives", iso2: "MV" },
  { id: 110, title: "Mali", iso2: "ML" },
  { id: 111, title: "Malte", iso2: "MT" },
  { id: 112, title: "Maroc", iso2: "MA" },
  { id: 113, title: "Maurice", iso2: "MU" },
  { id: 114, title: "Mauritanie", iso2: "MR" },
  { id: 115, title: "Mexique", iso2: "MX" },
  { id: 116, title: "Micronésie", iso2: "FM" },
  { id: 117, title: "Moldavie", iso2: "MD" },
  { id: 118, title: "Monaco", iso2: "MC" },
  { id: 119, title: "Mongolie", iso2: "MN" },
  { id: 120, title: "Monténégro", iso2: "ME" },
  { id: 121, title: "Mozambique", iso2: "MZ" },
  { id: 122, title: "Namibie", iso2: "NA" },
  { id: 123, title: "Nauru", iso2: "NR" },
  { id: 124, title: "Népal", iso2: "NP" },
  { id: 125, title: "Nicaragua", iso2: "NI" },
  { id: 126, title: "Niger", iso2: "NE" },
  { id: 127, title: "Nigeria", iso2: "NG" },
  { id: 128, title: "Norvège", iso2: "NO" },
  { id: 129, title: "Nouvelle-Zélande", iso2: "NZ" },
  { id: 130, title: "Oman", iso2: "OM" },
  { id: 131, title: "Ouganda", iso2: "UG" },
  { id: 132, title: "Ouzbékistan", iso2: "UZ" },
  { id: 133, title: "Pakistan", iso2: "PK" },
  { id: 134, title: "Palaos", iso2: "PW" },
  { id: 135, title: "Palestine", iso2: "PS" },
  { id: 136, title: "Panama", iso2: "PA" },
  { id: 137, title: "Papouasie-Nouvelle-Guinée", iso2: "PG" },
  { id: 138, title: "Paraguay", iso2: "PY" },
  { id: 139, title: "Pays-Bas", iso2: "NL" },
  { id: 140, title: "Pérou", iso2: "PE" },
  { id: 141, title: "Philippines", iso2: "PH" },
  { id: 142, title: "Pologne", iso2: "PL" },
  { id: 143, title: "Portugal", iso2: "PT" },
  { id: 144, title: "Qatar", iso2: "QA" },
  { id: 145, title: "République centrafricaine", iso2: "CF" },
  { id: 146, title: "République démocratique du Congo", iso2: "CD" },
  { id: 147, title: "République dominicaine", iso2: "DO" },
  { id: 148, title: "République tchèque", iso2: "CZ" },
  { id: 149, title: "Roumanie", iso2: "RO" },
  { id: 150, title: "Royaume-Uni", iso2: "GB" },
  { id: 151, title: "Russie", iso2: "RU" },
  { id: 152, title: "Rwanda", iso2: "RW" },
  { id: 153, title: "Saint-Christophe-et-Niévès", iso2: "KN" },
  { id: 154, title: "Saint-Marin", iso2: "SM" },
  { id: 155, title: "Saint-Vincent-et-les-Grenadines", iso2: "VC" },
  { id: 156, title: "Sainte-Lucie", iso2: "LC" },
  { id: 157, title: "Salvador", iso2: "SV" },
  { id: 158, title: "Samoa", iso2: "WS" },
  { id: 159, title: "Sao Tomé-et-Principe", iso2: "ST" },
  { id: 160, title: "Sénégal", iso2: "SN" },
  { id: 161, title: "Serbie", iso2: "RS" },
  { id: 162, title: "Seychelles", iso2: "SC" },
  { id: 163, title: "Sierra Leone", iso2: "SL" },
  { id: 164, title: "Singapour", iso2: "SG" },
  { id: 165, title: "Slovaquie", iso2: "SK" },
  { id: 166, title: "Slovénie", iso2: "SI" },
  { id: 167, title: "Somalie", iso2: "SO" },
  { id: 168, title: "Soudan", iso2: "SD" },
  { id: 169, title: "Soudan du Sud", iso2: "SS" },
  { id: 170, title: "Sri Lanka", iso2: "LK" },
  { id: 171, title: "Suède", iso2: "SE" },
  { id: 172, title: "Suisse", iso2: "CH" },
  { id: 173, title: "Suriname", iso2: "SR" },
  { id: 174, title: "Syrie", iso2: "SY" },
  { id: 175, title: "Tadjikistan", iso2: "TJ" },
  { id: 176, title: "Tanzanie", iso2: "TZ" },
  { id: 177, title: "Tchad", iso2: "TD" },
  { id: 178, title: "Thaïlande", iso2: "TH" },
  { id: 179, title: "Timor oriental", iso2: "TL" },
  { id: 180, title: "Togo", iso2: "TG" },
  { id: 181, title: "Tonga", iso2: "TO" },
  { id: 182, title: "Trinité-et-Tobago", iso2: "TT" },
  { id: 183, title: "Tunisie", iso2: "TN" },
  { id: 184, title: "Turkménistan", iso2: "TM" },
  { id: 185, title: "Turquie", iso2: "TR" },
  { id: 186, title: "Tuvalu", iso2: "TV" },
  { id: 187, title: "Ukraine", iso2: "UA" },
  { id: 188, title: "Uruguay", iso2: "UY" },
  { id: 189, title: "Vanuatu", iso2: "VU" },
  { id: 190, title: "Vatican", iso2: "VA" },
  { id: 191, title: "Venezuela", iso2: "VE" },
  { id: 192, title: "Viêt Nam", iso2: "VN" },
  { id: 193, title: "Yémen", iso2: "YE" },
  { id: 194, title: "Zambie", iso2: "ZM" },
  { id: 195, title: "Zimbabwe", iso2: "ZW" },
  { id: 196, title: "Iles Vierges britanniques", iso2: "VG" },
  { id: 197, title: "Îles Caïmans", iso2: "KY" },
  { id: 198, title: "Jersey", iso2: "JE" },
  { id: 199, title: "Iles des Bermudes", iso2: "BM" },
  { id: 200, title: "Iles Cook", iso2: "CK" },
  { id: 201, title: "Iles Féroé", iso2: "FO" },
  { id: 202, title: "Iles Maldives", iso2: "MV" },
  { id: 203, title: "Iles Marshall", iso2: "MH" },
  { id: 204, title: "Iles Salomon", iso2: "SB" },
  { id: 205, title: "Iles Turks et Caicos", iso2: "TC" },
  { id: 208, title: "Iles Wallis et Futuna", iso2: "WF" },
];
